(function() {
  'use strict';
  let tables = document.querySelectorAll('table');
  if (tables.length > 0) {
    for (let i = 0; i < tables.length; i++) {
      let toWrap = tables[i];
      let wrapper = document.createElement('div');
      wrapper.classList.add('table-scrollable');
      toWrap.parentNode.insertBefore(wrapper, toWrap);
      wrapper.appendChild(toWrap);
    }
  }
})();
